
'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export function TopLoader() {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const startLoading = () => {
      setIsVisible(true);
      setProgress(0); // Reset progress
      let currentProgress = 0;
      timer = setInterval(() => {
        currentProgress += Math.random() * 10;
        if (currentProgress > 95) {
          currentProgress = 95;
          clearInterval(timer);
        }
        setProgress(currentProgress);
      }, 200);
    };

    const finishLoading = () => {
      clearInterval(timer);
      setProgress(100);
      setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => setProgress(0), 500);
      }, 500);
    };

    // Use a reference to track the initial render
    const isInitialRender = !sessionStorage.getItem('TopLoader-Initial');
    if (isInitialRender) {
      sessionStorage.setItem('TopLoader-Initial', 'false');
    } else {
      startLoading();
    }
    
    // For subsequent navigations
    finishLoading();

    return () => {
      clearInterval(timer);
    };
  }, [pathname, searchParams]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 h-1 z-50">
      <div
        className="h-full bg-primary shadow-lg shadow-primary/50 transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
